import {vtoConstants} from './VTOConstants';

export const getWorkLocationSuccess = (response) => {
    return {
        type: vtoConstants.GET_WORK_LOC_SUCCESS,
        station: response
    }
}

export const getOffersDataSuccess = (response) => {
    return {
        type: vtoConstants.OFFERS_TABLE_SUCCESS,
        data: response
    }
}

export const getOffersDataFailed = (response) => {
    return {
        type: vtoConstants.OFFERS_TABLE_FAILED,
        data: response
    }
}

export const submitOffersBatchSuccess = (response) => {
    return {
        type: vtoConstants.SUBMIT_OFFERS_BATCH_SUCCESS,
        data: response
    }
}

export const submitConfirmRequestSuccess = (response) => {
    return {
        type: vtoConstants.SUBMIT_CONFIRM_REQUEST_SUCCESS,
        data: response
    }
}

export const getOfferDetailedDataSuccess = (response) => {
    return {
        type: vtoConstants.OFFER_DETAIL_SUCCESS,
        data: response
    }
}

export const showLoader = (response) => {
    return {
        type: vtoConstants.SHOW_LOADER,
        data: response
    }
}

export const submitRequestSuccess = (response) => {
    return {
        type: vtoConstants.SUBMIT_REQUEST_SUCCESS,
        data: response
    }
}

export const submitResponseSuccess = (response) => {
    return {
        type: vtoConstants.SUBMIT_RESPONSE_SUCCESS,
        data: response
    }
}

export const createOfferSuccess = (response) => {
    return {
        type: vtoConstants.CREATE_OFFERS_RESPONSE_SUCCESS,
        data: response
    }
}

export const getEmpReqSuccess = (response) => {
    return {
        type: vtoConstants.GET_EMP_REQ_SUCCESS,
        data: response
    }
}

export const getEmployeeShiftSuccess = (response) => {
    return {
        type: vtoConstants.GET_EMP_SHIFT_SUCCESS,
        data: response
    }
}

export const showError = (response) => {
    return {
        type: vtoConstants.SHOW_ERROR,
        data: response
    }
}

export const getRequestsBundleSuccess = (response) => {
    return {
        type: vtoConstants.GET_REQ_BUNDLE_SUCCESS,
        data: response
    }
}

export const setActionSuccess = (response) => {
    return {
        type: vtoConstants.ACTION_REQUEST_SUCCESS,
        data: response
    }
}

export const updateSlotsSuccess = (response) => {
    return {
        type: vtoConstants.UPDATE_SLOTS_SUCCESS,
        data: response
    }
}

export const submitReqResolutionSuccess = (response) => {
    return {
        type: vtoConstants.SUBMIT_REQ_RESOLUTION_SUCCESS,
        data: response
    }
}

export const showChangeLogLoader = (response) => {
    return {
        type: vtoConstants.GET_CHANGE_LOG_SUCCESS,
        data: response
    }
}

export const getChangeLogDataResponse = (response) => {
    return {
        type: vtoConstants.GET_CHANGE_LOG_RESPONSE,
        data: response
    }
}

export const getStationListSuccess = (response) => {
    return {
        type: vtoConstants.GET_VTO_STATION_LIST_SUCCESS,
        data: response
    }
}

export const getStationListResponse = (response) => {
    return {
        type: vtoConstants.GET_VTO_STATION_LIST_RESPONSE,
        data: response
    }
}

export const submitEditCutOff = (response) => {
    return {
        type: vtoConstants.SUBMIT_EDIT_CUT_OFF,
        data: response
    }
}
export const submitEditCutOffSuccess = (response) => {
    return {
        type: vtoConstants.SUBMIT_EDIT_CUT_OFF_SUCCESS,
        data: response
    }
}

export const addManualShift = (date, shift) => {
    return {
        type: vtoConstants.ADD_MANUAL_SHIFT,
        payload: { date, shift }
    };
};

export const deleteManualShift = (date, idx) => {
    return {
        type: vtoConstants.DELETE_MANUAL_SHIFT,
        payload: { date, idx }
    };
};
